import styled from "@emotion/styled"

export const Container = styled.div`
  max-width: 1000px;
  height: 100%;
  margin: 0 auto;
  padding: 30px;
  box-shadow: ${props => props.theme.shadow.skeumorphic};

  @media ${props => props.theme.breakpoint.tablet} {
    max-width: 700px;
    padding: 20px;
  }
  @media ${props => props.theme.breakpoint.mobile} {
    max-width: 500px;
    padding: 10px;
  }
`
